<template>
  <el-dialog :visible.sync="dialogVisible" :destroy-on-close="true" @close="onclose" title="撤回" top="10vh"
    class="dp-dialog">
    <div class="">
      <div class="main-page">
        <div class="revokebackgroundBox">
          <div class="main-contentBox">
            <div class="star-title">
              <span class="star"></span>特别提醒事项
            </div>
            <div class="contentBox tip-contentBox">
              <div class="textBox" v-if="applicantInfo.length > 1">
                现经沟通协商，申请人{{ applicantInfo[0].applicantName }}等{{ applicantInfo.length }}人自愿撤回本行政复议申请，请予准许。
              </div>
              <div class="textBox" v-else>
                现经沟通协商，申请人{{ applicantInfo[0].applicantName }}自愿撤回本行政复议申请，请予准许。
              </div>
            </div>
            <div class="btnLists">
              <div @click="interApply" v-if="isShow" class="primary-btn">生成撤回申请书 <span v-if="!isShow"> ( {{ downNumber }} )
                </span> </div>
              <div class="gary-btn" v-else>生成撤回申请书 ( {{ downNumber }} ) </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@api/api'
export default {
  props: {
    applicantInfo: {
      default: () => { return [] },
      type: Array,
      required: true
    },
    caseOrderNo: {
      type: String,
      required: true
    },
    inquireNo: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      checked: false,
      isShow: false,
      searchType: 0,
      downNumber: 5, // 倒数字
      dialogVisible: false
    }
  },
  created () {

  },
  methods: {
    open (searchType) {
      this.dialogVisible = true
      this.searchType = searchType // 存储是申请还是收案案件
      this.startDownNumber()
    },
    onclose () {
      this.dialogVisible = false
    },
    // 倒计时
    startDownNumber () {
      this.isShow = false
      this.downNumber = 5
      var times = setInterval(() => {
        console.log('====================================')
        this.downNumber--
        if (this.downNumber <= 0) {
          this.isShow = true
          clearInterval(times)
        }
      }, 1000)
    },
    // 撤回
    interApply () {
      const withdrawSource = +this.$route.query.searchType + 1
      let loading = this.$loading({
        Lock: true,
        text: '处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.WithdrawApplyExportWord({
        caseOrderNo: this.caseOrderNo,
        withdrawSource
      }).then(({ data }) => {
        this.$emit('openCh', data)
      }).finally(() => {
        loading.close()
        loading = null
        this.dialogVisible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .dp-dialog {
  ::v-deep .el-dialog {
    width:300px !important;

    .el-dialog__body {
      height: 300px !important;
      overflow-y: auto;
    }
  }
}
}

.dp-dialog {
  ::v-deep .el-dialog {
    width: 596px ;

    .el-dialog__body {
      height: 300px !important;
      overflow-y: auto;
    }
  }
}

.revokebackgroundBox {
  flex: 1;
  background-size: 104% 104%;
  background-position: -22px 0px !important;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.main-contentBox {
  .star-title {
    margin-bottom: 20px;
  }

  .tip-contentBox {
    height: 118px;
    overflow: auto;

    .textBox {
      padding: 0 20px;

      .paragraph {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #333333;
        line-height: 36px;
      }

      .text-content {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #666666;
        line-height: 28px;
        margin-left: 30px;
      }
    }
  }

  .checked-text {
    margin-top: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}
</style>
